import { useRequest } from '@polvo-labs/react-auth'
import React from 'react'
import { toast } from 'react-toastify'
import Text from '../../components/Text'
import UserType from '../../models/User'
import { Select } from './User/Show/styles'

export default function UpdateRole ({ user, onChange }: { user: UserType, onChange: () => void }) {
  const { request } = useRequest()

  const updateRole = (user: UserType, id?: string) => {

    request({
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/roles/grant`,
      data: {
        user,
        role: id ? {
          id,
        } : {},
      },
    }).then(() => {
      toast.success('Atualizado com sucesso')
      onChange()
    }).catch(() => {
      toast.error('Não foi possível atualizar')
    })
  }

  return (
    <Text
      tag="span"
    >
      Perfil:

      <div
        style={{
          position: 'relative',
        }}
      >
        <Select
          value={user.roles[0]?.id}
          onChange={e => {
            updateRole(user, e.target.value)
          }}
        >
          <option
            value=""
          >
            Comum
          </option>
          <option
            value={1}
          >
            Admin
          </option>
          <option
            value={2}
          >
            Operador
          </option>
        </Select>

        <span></span>
      </div>
    </Text>
  )
}
